import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutSidebar: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-sidebar, grid, window"><path d="M20.25 3.75H21V3H20.25V3.75ZM20.25 20.25V21H21V20.25H20.25ZM3.75 20.25H3V21H3.75V20.25ZM3.75 3.75V3H3V3.75H3.75ZM19.5 3.75V20.25H21V3.75H19.5ZM20.25 19.5H3.75V21H20.25V19.5ZM4.5 20.25V3.75H3V20.25H4.5ZM3.75 4.5H20.25V3H3.75V4.5Z" fill="currentColor"/><path d="M10.5 3.75V3H9V3.75H10.5ZM9 20.25V21H10.5V20.25H9ZM10.5 12V3.75H9V12H10.5ZM9 12V20.25H10.5V12H9Z" fill="currentColor"/><path d="M10 12H20" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutSidebar;
